import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const TranslateErrorMaxLengthDialog: React.FunctionComponent<ComponentProps> = props => {
  return (
    <Dialog id="exceeded-length-dialog" open={props.show} onClose={props.onClose} classes={{ container: "my-profile-confirmation-dialog", paper: "my-profile-confirmation-dialog-paper" }}>
      <DialogTitle>Maximum Length Exceeded</DialogTitle>
      <DialogContent>
        <DialogContentText style={{ color: 'black' }}>One or more auto translated fields exceeds the maximum character length allowed. Please review the highlighted fields and provide a new translation.</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button id="length-exceeded-ok-btn" variant="text" color="info" onClick={props.onClose}>Okay</Button>
      </DialogActions>
    </Dialog>
  );
}

interface ComponentProps {
  show: boolean;
  onClose: () => void;
}

export default TranslateErrorMaxLengthDialog;